export default __webpack_public_path__ + "static/media/group-org3.d8b19476.jpg";